export default [
  {
    header: 'Финансы',
    resource: 'finance',
    action: 'view',
  },
  {
    title: 'Финансы',
    route: 'finance',
    icon: 'DollarSignIcon',
    tagVariant: 'light-warning',
    resource: 'finance',
    action: 'view',
  },
]
